import { CustomerAPI, checkStatus, json } from '@drifthq/dapper'
import { stringify } from 'query-string'

export const verifyWidgetSnippet = (url, strict = true) => {
  return CustomerAPI
    .get(`/snippets/verify?${stringify({ url, strict })}`)
    .then(checkStatus)
    .then(json)
}



// WEBPACK FOOTER //
// ./src/modules/snippet/api.js